import React, { useState } from 'react';
import { profileApi } from '../../../services/api';
import AddEditModal from '../shared/AddEditModal';
import ItemCard from '../shared/ItemCard';

const projectFields = [
    { name: 'name', label: 'اسم المشروع', type: 'text', required: true, placeholder: 'منصة تجارة إلكترونية' },
    { name: 'type', label: 'نوع المشروع', type: 'select', options: [
        { value: 'personal', label: 'شخصي' },
        { value: 'professional', label: 'مهني' },
        { value: 'academic', label: 'أكاديمي' },
        { value: 'open-source', label: 'مفتوح المصدر' }
    ]},
    { name: 'role', label: 'دورك', type: 'text', placeholder: 'مطور رئيسي' },
    { name: 'description', label: 'الوصف', type: 'textarea', placeholder: 'وصف موجز للمشروع...' },
    { name: 'technologies', label: 'التقنيات', type: 'tags', placeholder: 'أضف تقنية...' },
    { name: 'url', label: 'رابط المشروع', type: 'url', placeholder: 'https://project.com' },
    { name: 'github_url', label: 'رابط GitHub', type: 'url', placeholder: 'https://github.com/user/project' },
    { name: 'start_date', label: 'تاريخ البداية', type: 'month', placeholder: '2023-01' },
    { name: 'end_date', label: 'تاريخ النهاية', type: 'month', placeholder: '2023-12' },
    { name: 'highlights', label: 'أبرز النقاط', type: 'list', placeholder: 'أضف نقطة...' },
    { name: 'skills_tags', label: 'المهارات', type: 'tags', placeholder: 'أضف مهارة...' },
    { name: 'importance', label: 'الأهمية', type: 'importance' }
];

export default function Projects({ profile, onRefresh }) {
    const [showModal, setShowModal] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [loading, setLoading] = useState(false);

    const projects = profile?.projects || [];

    const handleAdd = () => {
        setEditItem(null);
        setShowModal(true);
    };

    const handleEdit = (item) => {
        setEditItem(item);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm('هل أنت متأكد من حذف هذا المشروع؟')) return;
        setLoading(true);
        try {
            await profileApi.deleteProject(id);
            onRefresh('projects');
        } catch (err) {
            alert('فشل في حذف المشروع');
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async (data) => {
        setLoading(true);
        try {
            if (editItem) {
                await profileApi.updateProject(editItem.id, data);
            } else {
                await profileApi.addProject(data);
            }
            setShowModal(false);
            onRefresh('projects');
        } catch (err) {
            alert('فشل في حفظ المشروع');
        } finally {
            setLoading(false);
        }
    };

    const formatDateRange = (start, end) => {
        if (!start) return '';
        const startStr = start;
        const endStr = end || 'حالياً';
        return `${startStr} - ${endStr}`;
    };

    const renderCard = (project) => (
        <ItemCard
            key={project.id}
            title={project.name}
            subtitle={`مشروع ${project.type === 'personal' ? 'شخصي' : project.type === 'professional' ? 'مهني' : project.type === 'academic' ? 'أكاديمي' : project.type === 'open-source' ? 'مفتوح المصدر' : 'شخصي'}${project.role ? ` • ${project.role}` : ''}`}
            meta={[
                formatDateRange(project.start_date, project.end_date)
            ].filter(Boolean)}
            description={project.description}
            tags={project.technologies}
            importance={project.importance}
            highlights={project.highlights}
            links={{ url: project.url, github: project.github_url }}
            onEdit={() => handleEdit(project)}
            onDelete={() => handleDelete(project.id)}
        />
    );

    return (
        <div className="section-container">
            <div className="section-header">
                <h2 className="section-title">المشاريع</h2>
                <button className="add-button" onClick={handleAdd}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                    إضافة مشروع
                </button>
            </div>

            {projects.length === 0 ? (
                <div className="empty-state">
                    <div className="empty-state-icon">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <polyline points="16 18 22 12 16 6"></polyline>
                            <polyline points="8 6 2 12 8 18"></polyline>
                        </svg>
                    </div>
                    <h3 className="empty-state-title">لا توجد مشاريع بعد</h3>
                    <p className="empty-state-description">اعرض أفضل أعمالك بإضافة مشاريعك</p>
                    <button className="add-button" onClick={handleAdd}>أضف مشروعك الأول</button>
                </div>
            ) : (
                <div className="items-grid">
                    {projects.map(renderCard)}
                </div>
            )}

            {showModal && (
                <AddEditModal
                    title={editItem ? 'تعديل المشروع' : 'إضافة مشروع'}
                    fields={projectFields}
                    initialData={editItem || { type: 'personal' }}
                    onSave={handleSave}
                    onClose={() => setShowModal(false)}
                    loading={loading}
                />
            )}
        </div>
    );
}
